import React from 'react';
import classNames from 'classnames';
import { ColorSwatch, SwatchSize } from './ColorSwatch';
import './ColorSwatches.less';

export interface IColorSwatchesProps extends React.HTMLProps<{}> {
  colors: string[];
  className?: string;
  selectedIndex: number;
  onSelectColor?: (i: number) => void;
  swatchSize?: SwatchSize;
}

const getClassName = (className?: string) => classNames('dp-color-swatches', className);
const getSwatchClassName = (selected = false) =>
  classNames('dp-color-swatches__swatch', {
    'dp-color-swatches__swatch--selected': selected,
  });

/**
 * Color swatches to use, eg a palette display or editor.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function ColorSwatches({
  className,
  colors,
  selectedIndex,
  onSelectColor,
  swatchSize,
  children,
}: IColorSwatchesProps) {
  return (
    <section className={getClassName(className)}>
      {colors.map((color, i) => (
        <ColorSwatch
          key={i}
          color={color}
          className={getSwatchClassName(selectedIndex === i)}
          onClick={() => {
            onSelectColor?.(i);
          }}
          size={swatchSize}
        />
      ))}
      {children}
    </section>
  );
}
